import React, { useEffect, useRef, useState } from "react";
import { Checkbox } from "../ui/checkbox";
import ProjectDocumentDropdownMenu from "../ui/ProjectDocumentDropdownMenu";
import { formatDate, getDocumentIcon } from "@/utils/helpers";
import { ProjectDocument } from "@/types/project";

interface DocumentRowProps {
  doc: ProjectDocument;
  isChecked: boolean;
  onToggle: (id: string, checked: boolean) => void;
}

const DocumentRow: React.FC<DocumentRowProps> = ({
  doc,
  isChecked,
  onToggle,
}) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const icon = getDocumentIcon(doc.document_type);

  return (
    <div className="relative" ref={menuRef}>
      <div className="grid grid-cols-[500px_2fr_2fr_2fr] p-4 border-b transition">
        <div className="flex items-center ">
          <Checkbox
            checked={isChecked}
            onCheckedChange={(checked) => onToggle(doc.id, checked as boolean)}
          />
          <img
            src={icon}
            alt={`${doc.document_type} icon`}
            className="w-7 h-7 ml-12 mr-2"
          />
          <p className="text-gray-800 font-medium">{doc.title}</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>{formatDate(doc.uploaded_at || "")}</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>{formatDate(doc.updated_at || "")}</p>
        </div>
        <div className="text-sm text-gray-500 flex items-center space-x-20">
          <p>{doc.fileSize}</p>

          <div className="relative">
            <button
              onClick={toggleMenu}
              className="text-black hover:text-gray-700 font-black	text-2xl"
            >
              ...
            </button>
            {menuVisible && (
              <ProjectDocumentDropdownMenu
                closeMenu={() => setMenuVisible(false)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentRow;
